import { CalendarQueryProvider } from "../services/calendar"
import { CalendarHookProvider } from "../hooks/calendar"

export const CalendarHookQueryProvider = ({ children }) => {
    return (
        <CalendarQueryProvider>
            <CalendarHookProvider>{children}</CalendarHookProvider>
        </CalendarQueryProvider>
    )
}